import { render, staticRenderFns } from "./JBProposalPremisesGeneralProtection.vue?vue&type=template&id=015d75b3"
import script from "./JBProposalPremisesGeneralProtection.vue?vue&type=script&lang=js"
export * from "./JBProposalPremisesGeneralProtection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports